<div
  class="eventq-browser-tab"
  role="tab"
  [attr.aria-selected]="active()"
  [attr.tabindex]="active() ? 0 : -1"
  (click)="onSelect()"
  (pointerenter)="pointerenter.emit()"
  (pointerleave)="pointerleave.emit()"
>
  <span
    class="eventq-browser-tab__label"
    [matTooltip]="tooltipText()"
    [matTooltipDisabled]="active() || !hovered()"
    matTooltipPosition="below"
    matTooltipClass="eventq-browser-tab__tooltip"
    [matTooltipShowDelay]="500"
  >
    {{ label() }}
  </span>
  @if (runtimeLabel()) {
    <span class="eventq-browser-tab__runtime" aria-label="Processing time">{{ runtimeLabel() }}</span>
  }
  @if (expandEnabled()) {
    <button
      type="button"
      class="eventq-browser-tab__action eventq-browser-tab__expand"
      [attr.aria-label]="popoutMode() ? 'Close window' : expanded() ? 'Exit fullscreen' : 'Expand tab'"
      (click)="$event.stopPropagation(); expand.emit()"
    >
      <mat-icon>{{ popoutMode() || expanded() ? 'close_fullscreen' : 'open_in_full' }}</mat-icon>
    </button>
  }
  @if (closeEnabled()) {
    <button
      type="button"
      class="eventq-browser-tab__action eventq-browser-tab__close"
      aria-label="Close tab"
      (click)="$event.stopPropagation(); closed.emit()"
    >
      <mat-icon>close</mat-icon>
    </button>
  }
</div>
